module.exports = __webpack_public_path__ + "static/media/payment-pay.43fec79c.png";